import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  SCREEN_ID_ADMIN_MOVE_INS,
} from 'client/constants/screenIds';

import { USER_ROLE_ADMIN } from 'common/userRoles';

import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import branch from 'client/core/branch';
import allowedRoles from 'client/helpers/allowedRoles';

import SrPage from 'client/components/SrPage';
import SrDataTablePartnerHouseholdMoveIns from 'client/components/SrDataTablePartnerHouseholdMoveIns';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

import AccountManagerActions from 'client/actions/AccountManager';

@withTransitionHook
@allowedRoles({
  roles: [
    USER_ROLE_ADMIN,
  ],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withScreenId(SCREEN_ID_ADMIN_MOVE_INS)
@withScrollToTop
@branch(() => ({
  currentUser: ['currentUser'],
  accountManagers: ['accountManagers', 'listWithPartners'],
}))
class AdminMoveInsPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Move-Ins',
    section: 'Admin',
  });

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    currentUser: PropTypes.object.isRequired,
    accountManagers: PropTypes.array,
  };

  constructor(props) {
    super(props);

    this.state = {
      accountManagerId: null,
    };
  }

  static fetchData(match, inject) {
    return Promise.all([
      AccountManagerActions.getListWithPartners(inject),
    ]);
  }

  render() {
    const {
      dispatch,
      currentUser,
      accountManagers,
    } = this.props;

    const { accountManagerId } = this.state;

    return (
      <SrPage navbarProps={{ redirectLogoTo: '/admin' }}>
        {accountManagers && accountManagers.length && (
          <SrBox margin='50px 90px -106px 545px' zIndex='5'>
            <SrText
              size='large'
              weight='medium'
              color='blueGreycliff'
              font='greycliff'
            >
              Account Manager:&nbsp;
            </SrText>
            <select onChange={(e) => this.setState({ accountManagerId: e.target.value })}>
              <option value=''>All</option>
              {accountManagers.map((accountManager) => (
                <option
                  selected={accountManagerId === accountManager.id}
                  value={accountManager.id}
                >
                  {accountManager.name}
                </option>
              ))}
            </select>
          </SrBox>
        )}
        <SrBox className='width-90'>
          <SrDataTablePartnerHouseholdMoveIns
            currentUser={currentUser}
            dispatch={dispatch}
            upcoming
            withBlankState
            showPartnerName
            showUninstallOrderDetails
            displayFilters
            accountManagerId={accountManagerId}
          />
        </SrBox>
      </SrPage>
    );
  }
}

AdminMoveInsPage.displayName = 'AdminMoveInsPage';

export default AdminMoveInsPage;
